export default "__VITE_ASSET__RckGxGAI__"